export const TKeyProspectRecord = {
  PROSPECT_RECORD_IDENTITY_TITLE: "PROSPECT_RECORD_IDENTITY_TITLE",
  PROSPECT_RECORD_MATCH_TITLE: "PROSPECT_RECORD_MATCH_TITLE",
  PROSPECT_RECORD_ADD_TITLE: "PROSPECT_RECORD_ADD_TITLE",
  PROSPECT_RECORD_FIT_SCORE: "PROSPECT_RECORD_FIT_SCORE",
  PROSPECT_RECORD_MIN_SCORE: "PROSPECT_RECORD_MIN_SCORE",
  PROSPECT_RECORD_SAVE: "PROSPECT_RECORD_SAVE",
  PROSPECT_RECORD_DUPLICATE: "PROSPECT_RECORD_DUPLICATE",
  PROSPECT_RECORD_UPDATE_EXISTING: "PROSPECT_RECORD_UPDATE_EXISTING",
  PROSPECT_RECORD_FIELD_FULLNAME: "PROSPECT_RECORD_FIELD_FULLNAME",
  PROSPECT_RECORD_FIELD_ROLE: "PROSPECT_RECORD_FIELD_ROLE",
  PROSPECT_RECORD_FIELD_PITCH: "PROSPECT_RECORD_FIELD_PITCH",
  PROSPECT_RECORD_FIELD_COMPANY: "PROSPECT_RECORD_FIELD_COMPANY",
  PROSPECT_RECORD_FIELD_COMPANY_TYPE: "PROSPECT_RECORD_FIELD_COMPANY_TYPE",
  PROSPECT_RECORD_FIELD_COMPANY_SIZE: "PROSPECT_RECORD_FIELD_COMPANY_SIZE",
  PROSPECT_RECORD_FIELD_INDUSTRY: "PROSPECT_RECORD_FIELD_INDUSTRY",
  PROSPECT_RECORD_FIELD_LOCATION: "PROSPECT_RECORD_FIELD_LOCATION",
  PROSPECT_RECORD_FIELD_EMAIL: "PROSPECT_RECORD_FIELD_EMAIL",
  PROSPECT_RECORD_FIELD_PHONE: "PROSPECT_RECORD_FIELD_PHONE",
  PROSPECT_RECORD_FIELD_LINKS: "PROSPECT_RECORD_FIELD_LINKS",
  PROSPECT_RECORD_ADD_LINK: "PROSPECT_RECORD_ADD_LINK",
  PROSPECT_RECORD_FIELD_PROFILE_URL: "PROSPECT_RECORD_FIELD_PROFILE_URL",
  PROSPECT_RECORD_FIELD_SOURCE: "PROSPECT_RECORD_FIELD_SOURCE",
  PROSPECT_RECORD_PH_FULLNAME: "PROSPECT_RECORD_PH_FULLNAME",
  PROSPECT_RECORD_PH_ROLE: "PROSPECT_RECORD_PH_ROLE",
  PROSPECT_RECORD_PH_PITCH: "PROSPECT_RECORD_PH_PITCH",
  PROSPECT_RECORD_PH_COMPANY: "PROSPECT_RECORD_PH_COMPANY",
  PROSPECT_RECORD_PH_COMPANY_TYPE: "PROSPECT_RECORD_PH_COMPANY_TYPE",
  PROSPECT_RECORD_PH_COMPANY_SIZE: "PROSPECT_RECORD_PH_COMPANY_SIZE",
  PROSPECT_RECORD_PH_INDUSTRY: "PROSPECT_RECORD_PH_INDUSTRY",
  PROSPECT_RECORD_PH_LOCATION: "PROSPECT_RECORD_PH_LOCATION",
  PROSPECT_RECORD_PH_EMAIL: "PROSPECT_RECORD_PH_EMAIL",
  PROSPECT_RECORD_PH_PHONE: "PROSPECT_RECORD_PH_PHONE",
  PROSPECT_RECORD_PH_LINKS: "PROSPECT_RECORD_PH_LINKS",
  PROSPECT_RECORD_PH_PROOF: "PROSPECT_RECORD_PH_PROOF",
  PROSPECT_RECORD_PROOF_REQUIRED: "PROSPECT_RECORD_PROOF_REQUIRED",
  PROSPECT_RECORD_PH_PROFILE_URL: "PROSPECT_RECORD_PH_PROFILE_URL",
  PROSPECT_RECORD_PH_SOURCE: "PROSPECT_RECORD_PH_SOURCE",
  PROSPECT_RECORD_VIEW_PROFILE: "PROSPECT_RECORD_VIEW_PROFILE",
  PROSPECT_RECORD_DETAIL_SIGNALS: "PROSPECT_RECORD_DETAIL_SIGNALS",
  PROSPECT_RECORD_DETAIL_TAB_ABOUT: "PROSPECT_RECORD_DETAIL_TAB_ABOUT",
  PROSPECT_RECORD_DETAIL_TAB_FIT: "PROSPECT_RECORD_DETAIL_TAB_FIT",
  PROSPECT_RECORD_DETAIL_WHY_NOT: "PROSPECT_RECORD_DETAIL_WHY_NOT",
} as const;
